import { UserService } from '@/services/api/userApiArea/UserService';
import { UserServiceType } from '@/services/api/userApiArea/interface';

/** Метод userApiArea возвращает экземпляр UserService. По необходимости можно реализовать снгл тон. **/
export const userApiArea: { (): UserServiceType } = () => new UserService();
